import { h, Fragment } from 'preact';
import { useEffect } from 'preact/hooks';
import { useProduct } from './product-context';

const FauxOptions = () => {
  const {
    activeProduct,
    allLengths,
    allProducts,
    setActiveLength,
    handleProductChange,
  } = useProduct();

  allLengths.sort((a, b) =>
    a.localeCompare(b, navigator.languages[0] || navigator.language, {
      numeric: true,
      ignorePunctuation: true,
    }),
  );

  if (!activeProduct.tags.filter((tag) => tag.includes('length'))[0]) return;
  const activeTag = activeProduct.tags.filter((tag) => tag.includes('length'))[0];

  const handleLengthChange = (length) => {
    setActiveLength(length);
    const newProd = allProducts.find((product) => product.lengthTag === length);
    handleProductChange(newProd.handle);
  };

  useEffect(async () => {
    let allButtons = document.querySelectorAll('.lengthButton');
    allButtons.forEach((button) => {
      const buttonLength = button.getAttribute('data-length');
      if (activeTag == buttonLength) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  }, []);

  return (
    <>
      <div className="uppercase text-[14px] leading-[18px] mb-[12px]">
        Length
      </div>
      <div
        className="flex flex-wrap gap-y-[10px] gap-x-[8px] mb-[12px]"
        id="lengthselector"
      >
        {[...allLengths].map((length) => (
          <button
            className={`flex items-center justify-center px-[14px] py-[10px] rounded-md text-sm border lengthButton`}
            data-length={length}
            onClick={() => {
              handleLengthChange(length);
            }}
          >
            {length.replace('length::', '')}
          </button>
        ))}
      </div>
    </>
  );
};

export default FauxOptions;
